import { CMError } from '../../interfaces/interfaces';

/**
 * Angular mirror of C# SoilWebProperties
 */
export interface ISoilWebProperties {
	Record: ISoilWebRecord,
	Layers: ISoilLayer[],
	Error?: number
}

export interface ISoilWebRecord {
	Id: number,
	CoKey: string,
	Name: string,
	Series: string,
	Texture: string,
}

/**
 * Angular version of C# interface of the same name
 */
export interface ISoilLayer {
	Depth: number,
	Sand?: number,
	Silt?: number,
	Organic?: number,
	Density?: number,
	Tension?: number,
	Mineralization?: number
}

export enum ISoilLayerFields {
	SAND = 'Sand',
	SILT = 'Silt',
	ORGANIC = 'Organic',
	DENSITY = 'Density',
	TENSION = 'Tension',
	MINERALIZATION = 'Mineralization'
}

/**
 * Soil data received from server when we choose a lot in planting settings
 */
export interface CombinedSoilProperties {
	SoilWebProperties: ISoilWebProperties,
	CustomSoilLayers: ISoilLayer[]
}

export interface ISoilProperty {
	key: string,
	display: string,
	unit: string
}

export interface ISoilTypeLayer {
	Id: number,
	SoilTypeId: number,
	Depth: number,
	Sand: number,
	Silt: number,
	Organic: number,
	Density: number,
	Tension: number,
	Mineralization: number
}

export interface ISoilTypeService {
	getSoilWebRecord(coords: string): Promise<ISoilWebProperties | CMError >,
	getSoilPropertiesByLot(lotId: number): Promise<CombinedSoilProperties>,
}
